// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { blogApis } from '../../Data/axios';
// import Header from '../../Components/Header';
// import Footer from '../../Components/Footer';  

// import config from "../../Data/AuthUser";

// const BlogDetails = () => {
//   const { id } = useParams();
//   const [blog, setBlog] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchBlogDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await blogApis.getById(id); // Assuming `getById` fetches blog details by ID
//         console.log("API Response:", response
//         ); // Log the API response
//         console.log(response.data);
//         setBlog(response);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch blog details');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBlogDetails();
//   }, [id]);

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p className="text-red-500">{error}</p>;

//   // Add a conditional check for `blog`
//   if (!blog) return <p>No blog details available.</p>;

//   const getEmbedUrl = (url) => {
//     const videoIdMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
//     return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
//   };

//   return (
//     <>
//     <Header />
//     <div className="container mx-auto px-4 py-8 max-w-7xl font-ubuntu">
//       <h1 className="text-3xl font-bold mb-4">{blog.title}</h1>
//       {blog.youtube ? (
//         <iframe
//           width="100%"
//           height="500"
//           src={getEmbedUrl(blog.youtube)}
//           title={blog.title}
//           frameBorder="0"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//           allowFullScreen
//         ></iframe>
//       ) : blog.image ? (
//         <img
//           src={`${config.apiImageUrl}${blog.image}`}
//           alt={blog.title}
//           className="w-full h-auto mb-4"
//         />
//       ) : null}
//       <p className="text-gray-600 mb-4">{blog.description}</p>
//       <div className="text-gray-700 mt-4">{blog.content}</div>
//     </div>
//     <Footer />
//     </>
//   );
// };

// export default BlogDetails;

// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { blogApis } from '../../Data/axios';
// import Header from '../../Components/Header';
// import Footer from '../../Components/Footer';

// import config from "../../Data/AuthUser";

// const BlogDetails = () => {
//   const { id } = useParams();
//   const [blog, setBlog] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchBlogDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await blogApis.getById(id);
//         setBlog(response);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch blog details');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBlogDetails();
//   }, [id]);

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p className="text-red-500">{error}</p>;

//   if (!blog) return <p>No blog details available.</p>;

//   const getEmbedUrl = (url) => {
//     const videoIdMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
//     return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
//   };

//   return (
//     <>
//       <Header />
//       <div className="container mx-auto px-6 py-12 max-w-4xl mt-10 mb-20 bg-gray-100 font-ubuntu text-gray-900 rounded-lg shadow-md">
//         <div className="space-y-6">
//           <h1 className="text-5xl font-bold text-csyellow leading-tight">{blog.title}</h1>
//           <div className="flex flex-wrap space-x-2 text-sm text-gray-600">
//             <span className="p-1">#{blog.type === 1 ? 'Blog' : 'Other'}</span>
//             <span className="p-1">#{blog.status === 1 ? 'Published' : 'Draft'}</span>
//           </div>
//           <p className="text-sm text-gray-600 mb-8">
//             Posted on{' '}
//             <time>{new Date(blog.created_at).toLocaleDateString()}</time>
//           </p>
//         </div>
//         <div className="mb-6 mt-8">
//         {blog.youtube ? (
//           <iframe
//             width="100%"
//             height="500"
//             src={getEmbedUrl(blog.youtube)}
//             title={blog.title}
//             frameBorder="0"
//             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//             allowFullScreen
//             className="rounded-lg shadow-md"
//           ></iframe>
//         ) : blog.image ? (
//           <img
//             src={`${config.apiImageUrl}${blog.image}`}
//             alt={blog.title}
//             className="w-full h-auto rounded-lg shadow-md"
//           />
//         ) : null}
//         </div>
//         <p className="text-gray-800 mt-6">{blog.description}</p>
//         <div className="text-gray-800 mt-6">{blog.content}</div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default BlogDetails;


import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { blogApis } from '../../Data/axios';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import config from "../../Data/AuthUser";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        setLoading(true);
        const response = await blogApis.getById(id);
        setBlog(response);
      } catch (err) {
        setError(err.message || 'Failed to fetch blog details');
      } finally {
        setLoading(false);
      }
    };
    fetchBlogDetails();
  }, [id]);

  const getEmbedUrl = (url) => {
    const videoIdMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
          <div className="animate-pulse flex flex-col items-center">
            <div className="h-8 w-8 mb-4 border-t-4 border-csyellow border-solid rounded-full animate-spin"></div>
            <p className="text-gray-600 font-medium">Loading article...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md text-center">
            <div className="text-red-500 text-5xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Something went wrong</h2>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-csyellow hover:bg-yellow-600 text-white font-medium py-2 px-4 rounded-md transition duration-300"
            >
              Try Again
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <Header />
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md text-center">
            <div className="text-gray-400 text-5xl mb-4">📄</div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Article Not Found</h2>
            <p className="text-gray-600 mb-6">No blog details are available for this article.</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 font-ubuntu sm:px-6 lg:px-8 max-w-4xl">
          {/* Hero section with image or video */}
          <div className="mb-10">
            {blog.youtube ? (
              <div className="rounded-xl overflow-hidden shadow-xl">
                <iframe
                  width="100%"
                  height="500"
                  src={getEmbedUrl(blog.youtube)}
                  title={blog.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="aspect-video"
                ></iframe>
              </div>
            ) : blog.image ? (
              <div className="rounded-xl overflow-hidden shadow-xl">
                <img
                  src={`${config.apiImageUrl}${blog.image}`}
                  alt={blog.title}
                  className="w-full h-auto object-cover"
                />
              </div>
            ) : null}
          </div>

          {/* Article content */}
          <article className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="p-8 md:p-10">
              {/* Tags and metadata */}
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-csyellow bg-opacity-10 text-csyellow px-3 py-1 rounded-full text-sm font-medium">
                  #{blog.type === 1 ? 'Blog' : 'Other'}
                </span>
                <span className={`${blog.status === 1 ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'} px-3 py-1 rounded-full text-sm font-medium`}>
                  #{blog.status === 1 ? 'Published' : 'Draft'}
                </span>
              </div>

              {/* Title */}
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                {blog.title}
              </h1>

              {/* Publication date */}
              <div className="flex items-center text-gray-500 mb-8 text-sm">
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
                <time dateTime={blog.created_at}>
                  {(() => {
                    const d = new Date(blog.created_at);
                    const dd = String(d.getDate()).padStart(2, "0");
                    const mm = String(d.getMonth() + 1).padStart(2, "0");
                    return `${dd}-${mm}-${d.getFullYear()}`;
                  })()}
                </time>
              </div>

              {/* Description - with enhanced styling */}
              <div className="border-l-4 border-csyellow pl-4 mb-8 italic text-gray-700">
                {blog.description}
              </div>

              {/* Main content */}
              <div className="prose prose-lg max-w-none text-gray-800">
                {blog.content}
              </div>
            </div>
          </article>

          {/* Navigation buttons */}
          <div className="mt-12 flex justify-between">
            <button
              onClick={() => window.history.back()}
              className="flex items-center text-gray-600 hover:text-csyellow transition duration-300"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetails;